module.exports = __webpack_public_path__ + "img/email.9e5bcdb4.svg";